import logo from './logo.svg';
import './App.css';
import EntryContent from './pages/EntryContent/EntryContent.js'
function App() {
  return (
    <>
      <EntryContent></EntryContent>
    </>
  );
}

export default App;
